export default class EmployeeActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_EMPLOYEE='GET_HELPER_EMPLOYEE';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static submit(){
    return {
      type: EmployeeActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: EmployeeActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: EmployeeActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: EmployeeActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: EmployeeActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: EmployeeActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type: EmployeeActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type: EmployeeActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: EmployeeActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: EmployeeActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: EmployeeActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: EmployeeActions.GET_HELPER_EMPLOYEE,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: EmployeeActions.ERROR_SERVER,
      payload: error
    };
  }
}